/**
 * 이 파일은 Aui 의 일부입니다. (https://aui.moimz.tools)
 *
 * Include 필드 클래스를 정의한다.
 *
 * @file /src/components/form/field/include/Include.ts
 * @author sungjin <esung246@naddle.net>
 * @license MIT License
 * @modified 2026. 8. 5.
 */
import * as parent from '@components/form/field/Field';
import { Dom } from '@utils/Dom';
import { Html } from '@utils/Html';
import { LanguageText } from '@utils/Language';

export interface Listeners<T> extends parent.Listeners<T> {}

export interface Properties<T> extends parent.Properties<T> {
    /**
     * 이벤트리스너
     */
    listeners?: Listeners<T>;
}

export class Include extends parent.Field {
    /**
     * 컴포넌트 확장타입
     */
    variant = 'include';

    /**
     * Include Dom
     */
    $include: Dom = null;

    /**
     * Include 필드 클래스를 정의한다.
     *
     * @param properties - 초기설정
     */
    constructor(public properties: Properties<Include> = null) {
        super(properties);
    }

    /**
     * Include 필드 DOM 을 가져온다.
     *
     * @returns Include 필드 DOM
     */
    $getInclude(): Dom {
        if (this.$include === null) {
            this.$include = Html.create('div');
        }

        return this.$include;
    }

    /**
     * 필드값을 지정한다.
     *
     * @param value - 값
     * @param is_init - 초기값여부
     */
    async setValue(value: LanguageText | any, is_init: boolean = false): Promise<void> {
        await this.lockValue();

        // @todo

        await this.releaseValue(value, is_init);
    }

    /**
     * 필드값을 가져온다.
     *
     * @returns 필드값
     */
    async getValue(): Promise<any> {
        return null;
    }

    /**
     * 필드영역을 렌더링한다.
     */
    async renderField(): Promise<void> {
        this.$getContent().append(this.$getInclude());
    }
}
